import React, { useContext, useEffect, useState, useRef } from "react";
import $ from "jquery";
import {
  displayThumbnail,
  prefetchData,
  stopPrefetchData,
} from "../../helpers/CornerstoneThumbnailService";
import { Icon, PrimaryButton, ProgressIndicator, Stack,TooltipHost  } from "@fluentui/react";
import { PauseIcon, PlaySolidIcon } from "@fluentui/react-icons-mdl2";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import {
  enableVOISync,
  loadMPR,
} from "../../helpers/CornerstoneViewportService";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost"
import * as cornerstone from "@cornerstonejs/core";
import {
  THUMBNAIL_BATCH_SIZE,
  THUMBNAIL_FETCH_SIZE,
  TOAST_TYPE,
  LATERAL_VIEW_MODALITY_LIST,
} from "../../../../constants/Constants";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { isMobile } from "react-device-detect";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import loaderContext from "../../../../context/loader/LoaderContext";
import { isReconstructable } from "../../helpers/MPRService";
import { readMultiFrameMetadata, isInstanceCached } from "../../helpers/MultiFrameService";
import { useTranslation } from "react-i18next";
import toastContext from "../../../../context/toast/ToastContext";
import { WindowLevelTool } from "@cornerstonejs/tools";
import ProgressBar from "./ProgressBar";
import {
  resetOriginalImageState,
  buildSeriesDataFromStack,
} from "../../helpers/ViewerHelperService";
import Spinner from "../../../../components/Spinner/Spinner";
import themeContext from "../../../../context/theme/ThemeContext";
//added for quality flag

import useImageQuality from "../../../../hooks/useImageQuality";
import QualityIcon from "../../../../components/QualityIcon/QualityIcon";


const imageCountSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M9.24809 1.81334C9.68603 1.96724 10 2.38445 10 2.875V7.875C10 9.0486 9.0486 10 7.875 10H2.875C2.38445 10 1.96724 9.68603 1.81334 9.24809L2.86198 9.24978L7.875 9.25C8.63439 9.25 9.25 8.63439 9.25 7.875V2.875L9.24801 2.84951L9.24809 1.81334ZM7.62341 0C8.24473 0 8.74841 0.50368 8.74841 1.125V7.62341C8.74841 8.24473 8.24473 8.74841 7.62341 8.74841H1.125C0.50368 8.74841 0 8.24473 0 7.62341V1.125C0 0.50368 0.50368 0 1.125 0H7.62341Z"
      fill="#747474"
    />
  </svg>
);

const Thumbnail = ({
  stack,
  index,
  originalStack,
  heatmapStack,
  outlineStack,
  isPriors,
  studyIndex,
  priors,
  loadThumbnail = false, // Added loadThumbnail prop
  startIndex,
  lastIndex,
  dropDownClicked
}) => {
  const {
    activeThumbnailIndex,
    changeActiveThumbnailIndex,
    lateralThumbnailIndex,
    activeMPRThumbnailIndex,
    setActiveMPRThumbnailIndex,
    setActiveModality,
    stackScrollActiveThumbnailIndex,
    setActiveStudyId,
    checkIfParentStudyThumbnailIsLoaded,
    setThumbnailLoadingComplete,
    loadUptoIndex,
    setLoadUptoIndex,
    checkForThumbnailReinference,
    setStackScrollActiveThumbnailIndex,
    thumbnailLoadMap, setThumbnailLoadMap
  } = useContext(ThumbnailContext);

  const {
    stackSize,
    setProgress,
    progress,
    setThumbnailLoaded,
    studyModality,
    priorStudyData,
    studyParentId,
    forceReinferenceImageIds,
    prefetchCount,
    isHPApplied,
    hpNotFound,
    hpDataList,
    keyImages,
    priorStudyKeyImages,
    keyObjectImages,
    priorStudyKeyObjectImages,
    prImages,
    priorStudyPRImages,
    studyResponseData
  } = useContext(studyviewerContext);

  const {
    activeViewportIndex,
    changeViewportSeriesData,
    isMPRActive,
    setMprSeriesData,
    setIsMPRActive,
    setActiveMPRTool,
    setMprLoading,
    setDragEvent,
    setMprViewportElements,
    setIsMPRViewportActivated,
    setOriginalImageActiveState,
    originalImageActiveState,
    viewportSeriesData,
    viewportRow,
    viewportColumn,
    setMPRViewportLoaderRunning,
    imageLoadedOnViewport,
    setVolumeId,
    isMPREnabled,
    setIsMPREnabled,
    hPThumbnailIds
  } = useContext(ViewportContext);
  const{getAlterColor}=useContext(themeContext)

  const { setSeriesMenu } =
    useContext(studyviewerContext);

  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);

  const { t } = useTranslation();

  //added for quality flag
  const { seriesErrorsMap } = useImageQuality(studyResponseData);
  const seriesErrors = seriesErrorsMap[String(stack.seriesId)] || [];


  const [prefetchState, setPrefetchState] = useState(false);
  const [element, setElement] = useState();

  const [progressComplete, setProgressComplete] = useState({
    imageIds: stack.imageIds.slice(0),
    total: stack.imageIds.length,
    remaining: stack.imageIds.length,
    percentComplete: 0,
  });

  const [thumbnailLoading, setThumbnailLoading] = useState(true);
  const [multiFrameInfo, setMultiFrameInfo] = useState({
    isMultiFrame: false,
    numberOfFrames: 0,
  });

  const [seriesModality, setSeriesModality] = useState(stack.modality);
  useEffect(() => {
    setSeriesModality(stack.modality);
  }, []);

  // Tracks whether the index===0 auto-load has already fired so the
  // hpNotFound-watcher effect below doesn't double-fire with the inline
  // auto-load in enableThumbnailViewport.
  const autoLoadFiredRef = useRef(false);

  // Latest hpNotFound value accessible inside async functions without
  // stale-closure issues (enableThumbnailViewport is defined in the
  // component body but called from a [] mount effect).
  const hpNotFoundRef = useRef(hpNotFound);
  useEffect(() => { hpNotFoundRef.current = hpNotFound; }, [hpNotFound]);

  // Becomes true once displayThumbnail (or the SR fast-path) completes for
  // index 0, meaning the thumbnail viewport has had setStack called and
  // loadActiveViewport can safely read imageIds from it.
  const thumbnailZeroReadyRef = useRef(false);

  // Auto-load retry: fires when hpNotFound resolves after displayThumbnail
  // has already completed. The thumbnailZeroReadyRef guard prevents this
  // from racing with the in-flight metadata fetch for multiframe studies —
  // the post-displayThumbnail path in enableThumbnailViewport handles that
  // timing window instead.
  useEffect(() => {
    if (autoLoadFiredRef.current) return;
    if (index !== 0) return;
    if (hpNotFound == null) return;
    if (!stack || typeof stack !== "object" || !stack.studyId) return;
    if (!thumbnailZeroReadyRef.current) return;
    autoLoadFiredRef.current = true;
    setActiveModality(seriesModality);
    setActiveStudyId(stack.studyId);
    changeViewportSeriesData(
      buildSeriesDataFromStack(stack, originalStack, heatmapStack, outlineStack, seriesModality, 0, 0)
    );
  }, [hpNotFound, stack, index, seriesModality]);

  const activeThumbnailIndexRef = useRef(activeThumbnailIndex);
  useEffect(() => {
    activeThumbnailIndexRef.current = activeThumbnailIndex;
    //check if entire series is downloaded for the active thumbnail
    if(index === activeThumbnailIndex) {
      if(progressComplete.percentComplete === 1) {
        setIsMPREnabled(true);
      } else {
        setIsMPREnabled(false);
      }
    }
  }, [activeThumbnailIndex]);

  let remaining = stack.imageIds.length;
  let total = stack.imageIds.length;

  let intervalId;
  let hasCompleted = false;

  const onImageLoaded = (event) => {
    const imageId = event.detail.image.image.imageId;
    if (progressComplete.imageIds.includes(imageId)) {
      if (remaining > 0) remaining -= 1;
    }

    $(function () {
      intervalId = setInterval(() => {
        if (hasCompleted) return;
        // IMAGE_CACHE_IMAGE_ADDED only fires for NEWLY cached images, so any
        // instance already in the cache — the one the viewport already rendered,
        // or the thumbnail's own preview frame — never decrements `remaining`,
        // leaving multi-instance / multi-frame series stuck at ~99% forever
        // (seen in the priors viewer). Reconcile against the real cornerstone
        // cache each tick and take whichever signal reports more loaded, so the
        // bar can always reach 100% and clear.
        const cachedCount = progressComplete.imageIds.reduce(
          (n, id) => (isInstanceCached(id) ? n + 1 : n),
          0
        );
        const loaded = Math.max(total - remaining, cachedCount);
        const percentComplete = isPriors && total == 1 ? 1 : (total != 1 && loaded === 1) ? 0 : loaded / total;
        if (percentComplete === 1) {
          hasCompleted = true;
          clearInterval(intervalId);
          intervalId = null;
        }
        
        setProgressComplete({
          ...progressComplete,
          percentComplete: percentComplete,
          remaining: remaining
        });
        
        if(activeThumbnailIndexRef.current === index) {
          if(percentComplete === 1)
            setIsMPREnabled(true);
        }
      }, 1000);
    });
  };

  //start stop prefetch
  const togglePrefetching = async () => {
    if (seriesModality != "SR" && seriesModality != "PR") {
      if (!prefetchState) {
        setPrefetchState(!prefetchState);
        await prefetchData(index, onImageLoaded);
      } else {
        setPrefetchState(!prefetchState);
        await stopPrefetchData(index, onImageLoaded);
      }
    }
  };

  //load lateral series in for CT,MR
  useEffect(() => {
    if (lateralThumbnailIndex === index) {
      const seriesData = buildSeriesDataFromStack(
        stack, originalStack, heatmapStack, outlineStack,
        seriesModality, 1, index
      );
      changeViewportSeriesData(seriesData);
      if (stack.thumbnailImageIds.length > THUMBNAIL_FETCH_SIZE)
        togglePrefetching();
    }
  }, [lateralThumbnailIndex]);

  // useEffect(() => {
  //   const stopLoader = async (event) => {
  //     setThumbnailLoading(false);
  //   };

  //   if (element !== null) {
  //     element?.addEventListener(Enums.Events.IMAGE_RENDERED, stopLoader);

  //     return () => {
  //       element?.removeEventListener(Enums.Events.IMAGE_RENDERED, stopLoader);
  //     };
  //   }
  // }, [element]);

  // Mark THIS thumbnail as loaded. The batch-completion / loadUptoIndex advance
  // is handled centrally in ThumbnailState (a useEffect on thumbnailLoadMap), so
  // it re-evaluates on EVERY map change — including PR/KO/SR indices that render
  // no thumbnail and are treated as already-done. Doing the advance here raced
  // with those pre-marked indices and could leave a batch permanently incomplete,
  // stalling all later thumbnails/images when a study has derived (PR/KO) series.
  const updateThumbnailLoadMap = () =>{
    setThumbnailLoadMap((prevMap) => {
      if (prevMap.get(index) === true) return prevMap;
      const newMap = new Map(prevMap);
      newMap.set(index, true);
      return newMap;
    });
  }

  //enable thumbnail
  const enableThumbnailViewport = async () => {
    const ele = $("#stack_" + index).find("#thumbnail")[0];
    if (index === 0 && hpNotFoundRef.current) {
      setActiveModality(seriesModality);
      setActiveStudyId(stack.studyId);
      const seriesData = buildSeriesDataFromStack(
        stack, originalStack, heatmapStack, outlineStack,
        seriesModality, 0, 0
      );
      changeViewportSeriesData(seriesData);
    }
    if (seriesModality === "SR") {
      // SR viewports load synchronously — mark ready immediately and fire
      // auto-load if HP has already resolved. hpNotFoundRef.current avoids
      // the stale-closure issue (this function is called from a [] effect).
      if (index === 0) {
        thumbnailZeroReadyRef.current = true;
        if (hpNotFoundRef.current != null && !autoLoadFiredRef.current) {
          autoLoadFiredRef.current = true;
          setActiveModality(seriesModality);
          setActiveStudyId(stack.studyId);
          changeViewportSeriesData(
            buildSeriesDataFromStack(stack, originalStack, heatmapStack, outlineStack, seriesModality, 0, 0)
          );
        }
      }
    }
    if (seriesModality === "SR" || seriesModality === "PR") {
      setThumbnailLoaded(true);
      setThumbnailLoading(false);
      updateThumbnailLoadMap();
      return;
    }

    setElement(ele);
    cornerstone.eventTarget.addEventListener(
      cornerstone.EVENTS.IMAGE_CACHE_IMAGE_ADDED,
      (event) => onImageLoaded(event)
    );
    if (
      (stack.thumbnailImageIds.length <= prefetchCount || prefetchCount == -1) &&
      !isPriors
    ) {
      setTimeout(() => {
        // togglePrefetching();
      }, 1000);
    }
    // displayThumbnail (and its awaited ensureWadorsMetadataReady) can reject or
    // hang; without a try/finally the updateThumbnailLoadMap() below is skipped,
    // the batch never completes, and EVERY later thumbnail stalls at 0%. Guard
    // it so a single failing series can never wedge the whole panel.
    try {
      // Race displayThumbnail against a watchdog. If it neither resolves nor
      // rejects (a true hang, e.g. a /metadata fetch that never settles), the
      // timeout wins so we still advance the gate instead of deadlocking.
      const WATCHDOG_MS = 15000;
      let watchdog;
      const timeout = new Promise((_, reject) => {
        watchdog = setTimeout(
          () => reject(new Error(`displayThumbnail timed out after ${WATCHDOG_MS}ms (index=${index})`)),
          WATCHDOG_MS
        );
      });
      await Promise.race([
        displayThumbnail(
          ele,
          index,
          stack,
          stackSize,
          isPriors,
          priorStudyData,
          studyIndex,
          setThumbnailLoaded
        ),
        timeout,
      ]).finally(() => clearTimeout(watchdog));

      // The thumbnail viewport now has imageIds (setStack completed, including
      // any async /metadata pre-fetch for multiframe instances). Fire the
      // index-0 auto-load if HP has resolved. hpNotFoundRef.current gives the
      // current value — avoids the stale closure from the [] mount effect.
      if (index === 0) {
        thumbnailZeroReadyRef.current = true;
        if (hpNotFoundRef.current != null && !autoLoadFiredRef.current) {
          autoLoadFiredRef.current = true;
          setActiveModality(seriesModality);
          setActiveStudyId(stack.studyId);
          changeViewportSeriesData(
            buildSeriesDataFromStack(stack, originalStack, heatmapStack, outlineStack, seriesModality, 0, 0)
          );
        }
      }

      // A single-instance stack might still be a multi-frame DICOM; if so, surface
      // a ▶ badge on the thumbnail so users can distinguish cines from stills.
      // displayThumbnail has already loaded the first frame's dataset, so the
      // multiframeModule metadata-provider should resolve synchronously here.
      if (stack.imageIds && stack.imageIds.length === 1) {
        const mf = readMultiFrameMetadata(stack.imageIds[0]);
        if (mf && mf.NumberOfFrames > 1) {
          setMultiFrameInfo({
            isMultiFrame: true,
            numberOfFrames: mf.NumberOfFrames,
          });
        }
      }

      if (index === stackSize - 1) {
        setThumbnailLoadingComplete(true);
      }
    } catch (error) {
      // A thumbnail that fails/times out must not wedge the batch gate — log
      // and let the finally advance it.
      console.error("Thumbnail load failed for index", index, "modality", seriesModality, error);
    } finally {
      // Always advance the gate — even on failure — so later thumbnails load.
      setThumbnailLoading(false);
      updateThumbnailLoadMap();
    }
  };




  useEffect(()=> {
    if(index === 0){
      enableThumbnailViewport();
    }
    // SR/PR have no renderable image, so don't wait for imageLoadedOnViewport —
    // clear their spinner immediately and let the batch progress.
    if(index !== 0 && (seriesModality === "SR" || seriesModality === "PR")){
      enableThumbnailViewport();
    }
    if(index !== 0 && priors && loadThumbnail){
      enableThumbnailViewport();
    }

    if (
      typeof startIndex !== "undefined" &&
      typeof lastIndex !== "undefined" &&
      typeof isPriors !== "undefined" &&
      index > startIndex &&
      index <= lastIndex &&
      isPriors &&
      dropDownClicked
    ) {
      enableThumbnailViewport();
    }

  }, []);

  useEffect(() => {
    if (index !== 0 && hPThumbnailIds.includes(index)) {
      enableThumbnailViewport();
    }
  }, [hPThumbnailIds]);

  useEffect(() => {

    if(index === 0 || hPThumbnailIds?.includes(index)) return;

    const inCurrentBatch =
      (index + 1 <= loadUptoIndex) &&
      (index + 1 > loadUptoIndex - THUMBNAIL_BATCH_SIZE);

    if (!inCurrentBatch || dropDownClicked || loadThumbnail) return;

    if (imageLoadedOnViewport) {
      enableThumbnailViewport();
      return;
    }

    // Fallback: don't deadlock the panel if viewport 0 never reports loaded
    // (e.g. SR-only studies, hanging protocol leaves viewport 0 empty, or
    // SR's setTimeout-based flag never fires). Proceed after a short grace.
    const fallbackTimer = setTimeout(() => {
      enableThumbnailViewport();
    }, 2500);
    return () => clearTimeout(fallbackTimer);
  }, [loadUptoIndex, imageLoadedOnViewport]);

  const updateOriginalImageState = () => {
    resetOriginalImageState(originalImageActiveState, activeViewportIndex, setOriginalImageActiveState);
  };

  //change active thumbnail onclick
  const setActiveThumbnail = async () => {
    if (isMobile && thumbnailLoading && index !== 0) return;

    setActiveModality(seriesModality);
    setActiveStudyId(stack.studyId);
    if (!prefetchState && progressComplete.percentComplete < 1) {
      togglePrefetching();
    }

    if (isMobile) {
      setSeriesMenu(false);
    }
    if (isMPRActive) {
      setIsMPRActive(false);
    }

    updateOriginalImageState();

    changeActiveThumbnailIndex(index);
    setStackScrollActiveThumbnailIndex(index);
    const seriesData = buildSeriesDataFromStack(
      stack, originalStack, heatmapStack, outlineStack,
      seriesModality, activeViewportIndex, index
    );
    changeViewportSeriesData(seriesData);
  }
  // };

  useEffect(() => {
    if (stackScrollActiveThumbnailIndex === index ) {
      setActiveThumbnail();
    }
  }, [stackScrollActiveThumbnailIndex]);

  //series drag event handler
  const handleOnDrag = (e) => {
    setDragEvent(true);
    if (progressComplete.percentComplete < 1) {
      togglePrefetching();
    }

    const dragData = buildSeriesDataFromStack(
      stack, originalStack, heatmapStack, outlineStack,
      seriesModality, 0, index
    );
    // Add SR-specific field if applicable
    if (seriesModality === "SR" || seriesModality === "PR") {
      dragData.image = stack.thumbnailImageIds[0];
    }
    e.dataTransfer.setData("application/series-data", JSON.stringify(dragData));
  };

  // dragend fires on the source regardless of whether the drag was dropped on a
  // valid target. Without this, dragging a thumbnail without dropping it in a
  // viewport leaves dragEvent stuck true, permanently blocking the viewport's
  // image-load effects that are gated on `!dragEvent`.
  const handleOnDragEnd = () => {
    setDragEvent(false);
  };

  const [showTopBorder, setShowTopBorder] = useState(false);

  useEffect(() => {
    if (
      stack.studyId == studyParentId &&
      checkIfParentStudyThumbnailIsLoaded(
        studyParentId,
        viewportSeriesData,
        index
      )
    ) {
      setShowTopBorder(true);
    } else {
      setShowTopBorder(false);
    }
  }, [viewportSeriesData]);

  const [showTooltip, setShowTooltip] = useState(false);
  const descriptionRef = useRef(null);

  const handleMouseOver = ()=>{
    const el = descriptionRef.current;
    if(el && el.scrollWidth > el.clientWidth){
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  };

  // ── KO / PR badge computation ─────────────────────────────────────────────
  // KO markers now come from two sources: legacy key_image_title (keyImages) and
  // the dedicated key_object_description column (keyObjectImages).
  const allKI = isPriors
    ? [...(priorStudyKeyImages ?? []), ...(priorStudyKeyObjectImages ?? [])]
    : [...(keyImages ?? []), ...(keyObjectImages ?? [])];
  const koImageUrlSet = new Set(allKI.filter((ki) => ki.state !== "DELETED").map((ki) => ki.imageUrl));
  const hasKeyImages =
    stack.modality !== "PR" &&
    stack.modality !== "SR" &&
    stack.imageIds.some((id) => koImageUrlSet.has(id));

  // PR badge: use isPRPresent data from API (same pattern as keyImageTitle for KO)
  const allPR = isPriors ? (priorStudyPRImages ?? []) : (prImages ?? []);
  const prUrlSet = new Set(allPR.map((p) => p.imageUrl));
  const hasPRAnnotations =
    stack.modality !== "PR" &&
    stack.modality !== "SR" &&
    stack.imageIds.some((id) => prUrlSet.has(id));

  // Counts shown in the info row below the thumbnail.
  // Count total KO/PR documents (multiple per slice allowed), not unique slices.
  const stackImageIdSet = new Set(stack.imageIds);
  const koCount = (stack.modality !== "PR" && stack.modality !== "SR")
    ? allKI.filter((ki) => ki.state !== "DELETED" && stackImageIdSet.has(ki.imageUrl)).length
    : 0;
  const prCount = (stack.modality !== "PR" && stack.modality !== "SR")
    ? allPR.filter((p) => stackImageIdSet.has(p.imageUrl)).length
    : 0;

  return (
    <>
      <div
        id={`stack_${index}`}
        className={`thumbnail-container ${
          showTopBorder && priors ? "active-thumbnail-top-border" : ""
        }`}
        style={{ marginLeft: isMobile ? "2%" : "0" }}
      >
        <div
          className="thumbnail-box cursor-pointer"
          style={{
            borderColor: `${
              (activeMPRThumbnailIndex == index && isMPRActive) ||
              (activeThumbnailIndex == index && !isMPRActive)
                ? getAlterColor('#4da6ff','#0078D4')
                : viewportSeriesData.some(
                    (v, vi) =>
                      v.stack !== "" &&
                      v.thumbnailIndex === index &&
                      vi !== activeViewportIndex
                  )
                ? getAlterColor('rgb(255,255,255,0.85)','#4da6ff')
                : "rgb(255,255,255,0.3)"
            }`,borderWidth: `${
              (activeMPRThumbnailIndex == index && isMPRActive) ||
              (activeThumbnailIndex == index && !isMPRActive)
                ? "1px"
                : viewportSeriesData.some(
                    (v, vi) =>
                      v.stack !== "" &&
                      v.thumbnailIndex === index &&
                      vi !== activeViewportIndex
                  )
                ? "1px"
                : "1px"
            }`,
            // margin: isMobile ? "" : "auto",
            height: isMobile ? "150px" : "75px",
            position: 'relative',
            overflow: 'visible'
          }}

          onClick={(e) => {
            e.stopPropagation();
            setActiveThumbnail();
          }}
          draggable
          onDragStart={handleOnDrag}
          onDragEnd={handleOnDragEnd}
        >
          <div
            id="thumbnail"
            style={{
              display: `${seriesModality === "SR" || seriesModality === "PR" ? "none" : ""}`,
              pointerEvents: "none",
            }}
          ></div>
          {checkForThumbnailReinference(viewportSeriesData,forceReinferenceImageIds,index, stack) && <div className="force-retriage-progress">
          <CustomToolTipHost id="force-reinferece" content="AI Reinference is in progress...">
          <Icon style={{color: "white",marginTop:"5px"}} iconName="HourGlass" />
          </CustomToolTipHost>
          </div>}
          {seriesModality === "SR" && (
            <div className="thumbnail-sr-div">SR</div>
          )}
          {seriesModality === "PR" && (
            <div className="thumbnail-sr-div">PR</div>
          )}
          {thumbnailLoading && (
            <div className="thumbnail-spinner-div">
              {" "}
              <Spinner size={10} />{" "}
            </div>
          )}
          {multiFrameInfo.isMultiFrame && !thumbnailLoading && (
            <div
              className="thumbnail-multi-frame-badge"
              title={`Multi-frame cine · ${multiFrameInfo.numberOfFrames} frames`}
            >
              <PlaySolidIcon />
              <span className="thumbnail-multi-frame-count">
                {multiFrameInfo.numberOfFrames}
              </span>
            </div>
          )}
          {/* KO / PR badges with counts — bottom-right of the thumbnail image */}
          {(hasKeyImages || hasPRAnnotations) && (
            <div
              style={{
                position:        "absolute",
                bottom:          "4px",
                right:           "4px",
                display:         "flex",
                flexDirection:   "column",
                alignItems:      "flex-end",
                gap:             "3px",
                pointerEvents:   "none",
              }}
            >
              {hasKeyImages && (
                <div style={{
                  display:         "flex",
                  alignItems:      "center",
                  gap:             "3px",
                  background:      "rgba(0,0,0,0.55)",
                  borderRadius:    "3px",
                  padding:         "1px 4px",
                }}>
                  <svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 12.8589L12.944 16L11.632 10.08L16 6.09684L10.248 5.58316L8 0L5.752 5.58316L0 6.09684L4.368 10.08L3.056 16L8 12.8589Z" fill="#0085FF"/>
                  </svg>
                  <span style={{ color: "#e2e8f0", fontSize: "10px", fontWeight: "600", lineHeight: 1 }}>
                    {koCount}
                  </span>
                </div>
              )}
              {hasPRAnnotations && (
                <div style={{
                  display:         "flex",
                  alignItems:      "center",
                  gap:             "3px",
                  background:      "rgba(0,0,0,0.55)",
                  borderRadius:    "3px",
                  padding:         "1px 4px",
                }}>
                  <svg width="10" height="10" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.998047 14.998H3.91431L12.5153 6.39702L9.59908 3.48076L0.998047 12.0818V14.998ZM2.55339 12.7273L9.59908 5.68156L10.3145 6.39702L3.26884 13.4427H2.55339V12.7273Z" fill="#0085FF"/>
                    <path d="M12.9508 1.22552C12.6475 0.922224 12.1576 0.922224 11.8543 1.22552L10.4312 2.64865L13.3474 5.56491L14.7706 4.14178C15.0739 3.83849 15.0739 3.34855 14.7706 3.04526L12.9508 1.22552Z" fill="#0085FF"/>
                  </svg>
                  <span style={{ color: "#e2e8f0", fontSize: "10px", fontWeight: "600", lineHeight: 1 }}>
                    {prCount}
                  </span>
                </div>
              )}
            </div>
          )}
          {/* added for quality flag */}
          {isPriors && seriesErrors.length > 0 && (
            <QualityIcon
              errors={seriesErrors.map(e => e.class ? `${e.class} - ${e.message}` : e.message)}
              size="16px"
              style={{ position: 'absolute', top: '2px', right: '2px', zIndex: 10 }}
            />
          )}


        </div>
        <TooltipHost content={stack.seriesDescription} hidden={!showTooltip}>
        <div
          ref={descriptionRef}
          className="thummbnail-description"
          // style={{ padding: isMobile ? "0px" : "0px 2px" }}
          style={{
            padding: isMobile ? "0px" : "0px 2px",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          onMouseOver={handleMouseOver}
        >
          {stack.seriesDescription}
        </div>
        </TooltipHost>
        <div
          className="thumbnail-image-count"
          style={{
            marginLeft: isMobile ? "0%" : "3%",
          }}
        >
          <span>S : {stack.stackId}</span>
          <span>
            {imageCountSVG} : {stack.imageIds.length}
          </span>
        </div>
        {stack.modality !== "SR" && stack.modality !== "PR" && (
          <div className="thumbnail-progress-bar">
            {progressComplete.percentComplete < 1 && (
              <span
                className="cursor-pointer thumbnail-progress-icon"
                onClick={togglePrefetching}
              >
                {prefetchState ? (
                  <PauseIcon />
                ) : (
                  <PlaySolidIcon styles={{ color: "white" }} />
                )}
              </span>
            )}
            <span className="thumbnail-progress-indicator">
              <ProgressBar
                progressComplete={(
                  progressComplete.percentComplete * 100
                ).toFixed(0)}
              />
              {/* <ProgressIndicator
                barHeight={"5px"}
                styles={thumbnailProgressBarStyle}
                percentComplete={progressComplete.percentComplete}
              /> */}
            </span>
            {/* <span className="thumbnail-progress-percentage">
              {(progressComplete.percentComplete * 100).toFixed(0)}%
            </span> */}
          </div>
        )}
        {isMPRActive && activeMPRThumbnailIndex == index && (
          <div className="thumbnail-mpr-tag">{t("viewer.tools.mpr")}</div>
        )}
      </div>
    </>
  );
};

export default Thumbnail;
